import { memo } from 'react';
import { MoreVertical, Pencil, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shared/components/ui/shadcn/dropdown-menu';

interface DropdownActionsProps {
  onEdit?: () => void;
  onDelete?: () => void;
}

export const DropdownActions = memo(function DropdownActions({ onEdit, onDelete }: DropdownActionsProps) {
  const { t } = useTranslation('rolesModule');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="inline-flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          data-testid="dropdown-trigger"
          aria-label={t('table.actions.menu')}
        >
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" data-testid="dropdown-content">
        <DropdownMenuItem onClick={onEdit} data-testid="edit-role-button">
          <Pencil className="mr-2 h-4 w-4" />
          {t('table.edit')}
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem
          onClick={onDelete}
          className="text-destructive focus:text-destructive"
          data-testid="delete-role-button"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          {t('table.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
});
